import { render } from "./Contracts.vue?vue&type=template&id=af656a7a&scoped=true"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"

import "./Contracts.vue?vue&type=style&index=0&id=af656a7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af656a7a"

export default script